import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

export type BadgeTone =
  | 'neutral'
  | 'gray'
  | 'yellow'
  | 'green'
  | 'red'
  | 'blue'
  | 'teal'
  | 'red-soft'
  | 'gray-strong'
  | 'system';

const TONES: Record<BadgeTone, string> = {
  neutral:      'bg-[#F2F2F8] text-[#676687] border border-[#E3E3F1]',
  gray:         'bg-[#F2F2F8] text-[#676687] border border-[#E3E3F1]',
  yellow:       'bg-[#FFFBEB] text-[#B45309] border border-[#FDE68A]',
  green:        'bg-[#ECFDF5] text-[#047857] border border-[#A7F3D0]',
  red:          'bg-[#FEF2F2] text-[#B91C1C] border border-[#FECACA]',
  blue:         'bg-[#EFF0FF] text-[#0410BD] border border-[#A2A8FF]',
  teal:         'bg-[#D9FCFF] text-[#007998] border border-[#94F2FA]',
  'red-soft':   'bg-[#FEF2F2] text-[#B91C1C] border border-[#FECACA]',
  'gray-strong':'bg-[#E3E3F1] text-[#676687]',
  system:       'bg-[#EFF0FF] text-[#3F4CFF] border border-[#A2A8FF]',
};

export function Badge({
  tone = 'neutral',
  children,
  className,
}: {
  tone?: BadgeTone;
  children: ReactNode;
  className?: string;
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 px-2 py-0.5 rounded-[4px] text-[11px] font-semibold tracking-[0.02em]',
        TONES[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
